<template>
  <div class="statistics">
    <BellPage v-show="isBellPage" @change-view="showLogView"></BellPage>
    <LogPage v-if="!isBellPage" :device-code="showEquipCode" :room-name="roomName" @change-view="hideLogView"></LogPage>
  </div>
</template>

<script>
import LogPage from './logPage'
import BellPage from './bellPage'

export default {
  name: 'equipDoorbellMain',
  components: { LogPage, BellPage },
  data() {
    return {
      isBellPage: true,
      roomName: '',
      showEquipCode: ''
    }
  },
  mounted() {
    let curBellPageShowId = localStorage.getItem('curBellPageShowId')
    let curBellPageCodeId = localStorage.getItem('curBellPageCodeId')
    if (curBellPageShowId && curBellPageCodeId) {
      this.$nextTick(() => {
        this.showEquipCode = curBellPageCodeId
        this.isBellPage = false
      })
    }
  },
  methods: {
    showLogView(row) {
      this.bakePagination()

      localStorage.setItem('curBellPageShowId', row.id)
      localStorage.setItem('curBellPageCodeId', row.deviceCode)
      localStorage.removeItem('curUrlPageSize')
      localStorage.removeItem('curUrlPageIndex')

      this.roomName = row.roomName
      this.showEquipCode = row.deviceCode
      this.isBellPage = false
    },
    hideLogView() {
      localStorage.setItem('curUrlPageSize', this.bakePageSize || 10)
      localStorage.setItem('curUrlPageIndex', this.bakePageIndex || 1)
      localStorage.removeItem('curBellPageShowId')
      localStorage.removeItem('curBellPageCodeId')

      this.isBellPage = true
    },
    bakePagination() {
      this.bakePageSize = localStorage.getItem('curUrlPageSize')
      this.bakePageIndex = localStorage.getItem('curUrlPageIndex')
    }
  },
}
</script>
